import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlConsultaMetasEducacao = '/service/contabilidade/transparencia/metaEducacao/'

class ConsultaMetasEducacaoService extends BaseService {
    constructor() {
        super(NOME_TOKEN_ACESSO_DIRETO)
    }

    consultar(filtro) {
        let data = {
            exercicio: filtro.exercicio ? filtro.exercicio.value : '',
            mesLiquidacao: filtro.mesLiquidacao ? filtro.mesLiquidacao.value : '',
            descricaoMeta: filtro.descricaoMeta ? filtro.descricaoMeta.value : '',
        }

        return this.conex.post(urlConsultaMetasEducacao + 'consultaMetasEducacao/', JSON.stringify(data))
    }
}

export default ConsultaMetasEducacaoService
